var xss = require("xss");
import store from './store';

store.dispatch('getFingerId').then(async()=>{
  let firstLook=window.localStorage.getItem('firstLook');
  if(firstLook === 'true' && to.name !== 'cookiePolicy' && from.name !== 'cookiePolicy' && lastPageName !== 'cookiePolicy') {
    let params = {
      finger: store.getters.fingerId,
      optionType:1
    };
    let res = await setCookiesBanner(params);
    if(res.code === 0){
      window.localStorage.setItem('gaDisable', true);
      window.localStorage.setItem('firstLook', false);
    }
  }
});

const whiteList = require('./xss/white-list');
const cssWhiteList = require('./xss/css-white-list');
import {
  reportVisitUser, reportVisitPage, setCookiesBanner, gameDetailReportChannel,
  collectTime
} from "./util/APIUtils";
import {getChannel,getChannelGameId} from "./util/auth";

export function xssSignRecover(content) {
  if(content){
    let e = document.createElement('textarea');
    e.innerHTML = content;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }
}

export function convertTextValue(map){
  let select = [];
  console.log(map);
  let keys = Object.keys(map);
  keys.forEach((key)=>{
    select.push({
      "value": key.toLowerCase(),
      "text": map[key]
    });
  });
  return select;
}


export function isSafeDomain(domain, whiteList) {
  // domain must be string, otherwise return false
  if (typeof domain !== 'string') return false;
  // Ignore case sensitive first
  domain = domain.toLowerCase();
  // add prefix `.`, because all domains in white list start with `.`
  const hostname = '.' + domain;

  return whiteList.some(rule => {
    // Check whether we've got '*' as a wild character symbol
    if (rule.includes('*')) {
      return matcher.isMatch(domain, rule);
    }
    // If domain is an absolute path such as `http://...`
    // We can directly check whether it directly equals to `domain`
    // And we don't need to cope with `endWith`.
    if (domain === rule) return true;
    // ensure wwweggjs.com not match eggjs.com
    if (!/^\./.test(rule)) rule = `.${rule}`;
    return hostname.endsWith(rule);
  });
};

let xssOptions = { // 过滤文本配置
    whiteList,
    css: {
      whiteList: cssWhiteList,
    },
    escapeHtml(html) {
      // 对于vue框架的html字段过滤
      // replace(/{{(.*?)}}/g, '**$1**') 处理vue
      // helper.shtml(`{{[].pop.constructor('console.log(docum'+'ent.cookie)')()}}`)

      // .replace(/&([0-9a-z#]*?);/g, '') 处理特殊
      // '君莫笑&#8234;&#8236;&#8237;&zwj;&rlm;&lrm;&#8236;&#8203;&#8235;&#8237;⁠&zwnj;&#8234;&#8235;&zwj;&#8238;'
      return html.replace(/{{(.*?)}}/g, '**$1**').replace(/&([0-9a-z#]*?);/g, '');
    },
    onIgnoreTag(tag, html, options) {
      // 参数说明与onTag相同
      // 如果返回一个字符串，则当前标签将被替换为该字符串
      // 如果不返回任何值，则使用默认的处理方法（通过escape指定，详见下文）
      console.log('tag', tag);
      return html.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
    onTagAttr(tag, name, value, isWhiteAttr) {
      // tag是当前的标签名称，比如<a>标签，则tag的值是'a'
      // name是当前属性的名称，比如href="#"，则name的值是'href'
      // value是当前属性的值，比如href="#"，则value的值是'#'
      // isWhiteAttr是否为白名单上的属性
      // 如果返回一个字符串，则当前属性值将被替换为该字符串
      // 如果不返回任何值，则使用默认的处理方法
      //   在白名单上：  调用safeAttrValue来过滤属性值，并输出该属性，详见下文
      //   不在白名单上：通过onIgnoreTagAttr指定，详见下文

      if (isWhiteAttr && (tag === 'img' && name === 'data-src')) {
        if (!value) {
          return;
        }

        value = String(value);

        if (value[0] === '/' || value[0] === '#') {
          return;
        }

        try {
          let hostname = new URL(value).hostname;// A TypeError will be thrown if the input or base are not valid URLs.
          if (!hostname) {
            return '';
          }

          hostname = hostname.toLocaleLowerCase();
          if (!isSafeDomain(hostname, ['.gameexp.com', '.gameinfo.com', '.myqcloud.com'])) {
            return '';
          }
        } catch (e) {
          return '';
        }
      }
    },
};

export function xssHandler(content){
  let myxss = new xss.FilterXSS(xssOptions);
  return myxss.process(content);
}
// html获取params
export function urlCrop(id){
  return id.split('.')[0];
}

export function urlWithNameCrop(id){
  if(id){
    return id.split('.')[0].split('-').slice(-1)[0];
  }
}

export function urlWithName(name){
  if(name) {
    let reg = /^[A-Za-z0-9]+$/;
    let gameName = '';
    let charNum = 0;
    name.split(/[^A-Za-z0-9]/).filter(each => each).forEach((item, index) => {
      if(reg.test(item) && charNum <80){
        gameName += item.toLowerCase();
        charNum += item.length;
        if(index !== name.split(' ').length - 1) {
          gameName += '-';
        }
      }
    });
    gameName = gameName.charAt(gameName.length-1) === '-'? gameName.substr(0,gameName.length-1) : gameName;
    return gameName = gameName === ''? gameName:gameName+'-';
  }
  else return '';
}

export function testIdWithStatus(item){

  if(item.test){
    return item.test.id+'-'+item.displayStatus+'-'+item.gameTest+'-'+item.test.testType;
  }else {
    return item.testId+'-'+item.displayStatus+'-'+item.gameTest+'-'+item.testType;
  }

}

export function visitUserReport(channel, routerName, eventType){
  // store.dispatch('getFingerId').then(async()=>{
  //   reportVisitUser({channel: channel,
  //     routerName: routerName, fingerId: store.getters.fingerId, eventType});
  // })

}
export function visitPageReport(channel, routerName, eventType){
  // store.dispatch('getFingerId').then(async()=>{
  //   reportVisitPage({channel: channel,
  //     routerName: routerName, eventType: eventType});
  // })

}
export function reportTheChannel(reportType){
  let data = {
    reportType,
    uId: getChannelGameId(),
    fingerId: store.getters.fingerId,
    openId: store.getters.openId || '',
    channel: getChannel(),
  };
  // let encrypts = DES.encrypt(JSON.stringify(data));
  gameDetailReportChannel({data:data});

}

export const reportData = () => {
  let startTime = performance.now(); // 进入页面的时间点

  let logVisit = async function() {
    if (!navigator.sendBeacon) return false;
    const endeTime = performance.now(); // 页面卸载的时间点
    const second = (endeTime - startTime)/1000;
    const req = {
      "duration": second.toFixed(2)
    };
    collectTime(req);
  };
  window.addEventListener("beforeunload", logVisit);
};

// 检查外链接是否合法，在白名单中
export function validURL(sUrl) {
  // let domains = ['gameinfo.xyz', 'q.gameinfo.xyz', 'gameexp.com', 'www.gameexp.com', 'jp.gameexp.com', 'q.gameexp.com', 'survey.gameexp.com'];
  // let valid = false;
  // let url = sUrl.replace('http://www.','').replace('https://www.','').replace('http://','').replace('https://','');
  // for(let d of domains){
  //   if(checkDomain(d) || checkSubDomain(d)){
  //     valid = true;
  //     break;
  //   }
  // }
  let valid = false;
  if(checkProdDomain(sUrl) || checkTestDomain(sUrl) || checkSubProdDomain(sUrl) || checkSubTestDomain(sUrl)){
    valid = true;
  }
  return valid;
}

function checkProdDomain(sUrl) {
  return !!((/^(https?:\/\/)?[\w\-.]+\.(gameexp)\.(com)($|\/|\\)/i).test(sUrl) || (/^[\w][\w/.\-_%]+$/i).test(sUrl) || (/^[/\\][^/\\]/i).test(sUrl));
}
function checkTestDomain(sUrl) {
  return !!((/^(https?:\/\/)?[\w\-.]+\.(gameinfo)\.(xyz)($|\/|\\)/i).test(sUrl) || (/^[\w][\w/.\-_%]+$/i).test(sUrl) || (/^[/\\][^/\\]/i).test(sUrl));
}
function checkSubProdDomain(sUrl) {
  return !!((/^(https?:\/\/)?[A-Za-z]+\.(gameexp)\.(com)($|\/|\\)/i).test(sUrl) || (/^[\w][\w/.\-_%]+$/i).test(sUrl) || (/^[/\\][^/\\]/i).test(sUrl));
}
function checkSubTestDomain(sUrl) {
  return !!((/^(https?:\/\/)?[A-Za-z]+\.(gameinfo)\.(xyz)($|\/|\\)/i).test(sUrl) || (/^[\w][\w/.\-_%]+$/i).test(sUrl) || (/^[/\\][^/\\]/i).test(sUrl));
}
